import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, GroupGutter, Heading, HeadingSize, I18N_NAMESPACES, Image, Link, LinkVariant, Text, TextColor, useScrollPosition, } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetBasketMappedProductsState, makeGetBasketTotalQuantityState, } from '../../../redux/basket/selectors/BasketSelector';
import { useEffect, useLayoutEffect, useState, } from 'react';
import { getImageSourceSetByProductCode } from '../../../util/ImageUtil';
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { ButtonAlpha, Box, Popover, Scrollable, useMediaQueryMatchesOnDesktop, } from '@yonderland/andes-react';
import { makeGetFirstName, makeGetIsLoggedIn } from '../../../redux/session/selectors/SessionSelector';
import { NAVIGATION_HORIZONTAL, NAVIGATION_HORIZONTAL_COLLAPSE } from '../../../constants/DOMElementsConstants';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { EventActions } from '../../../enums/AnalyticsEnums';
import { DELAY } from '../../../constants/GeneralConstants';
import { MIN_SCREEN_WIDTH_DESKTOP } from '../../../constants/ScreenWidthConstants';
import BrowserUtil from '../../../util/BrowserUtil';
import { ProductImageHeight, ProductImageWidth } from '../../../constants/ProductConstants';
import { ArrowRightIcon } from '@yonderland/andes-icons';
const MAX_PRODUCTS = 5;
const POPOVER_OFFSET_DEFAULT = 24;
const POPOVER_OFFSET_COLLAPSED_NAV = 64;
const DESKTOP_IMAGE_WIDTH = 90;
const DESKTOP_IMAGE_HEIGHT = 136;
const USER_AGENT_FIREFOX = 'Firefox';
const overflowOptions = (_floatingElement, overflowValues, translate) => {
    if (!overflowValues || !translate)
        return;
    const isFixedPosition = overflowValues.top >= -POPOVER_OFFSET_DEFAULT;
    return {
        position: 'fixed',
        transform: `translate(${translate.x}px, ${isFixedPosition ? POPOVER_OFFSET_DEFAULT : Math.abs(overflowValues.top)}px)`,
    };
};
export const BasketReminderNotification = ({ hrefViewCart, children, }) => {
    const { productImageConfig } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const products = useSelector(makeGetBasketMappedProductsState());
    const isLoggedIn = useSelector(makeGetIsLoggedIn());
    const basketAmount = useSelector(makeGetBasketTotalQuantityState());
    const firstName = useSelector(makeGetFirstName());
    const [open, setOpen] = useState(false);
    const [popoverOffset, setPopoverOffset] = useState(POPOVER_OFFSET_DEFAULT);
    const [navigationEl, setNavigationEl] = useState(null);
    const dispatch = useDispatch();
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const isFirefox = BrowserUtil.detectBrowser(USER_AGENT_FIREFOX);
    const onViewBasketClick = (event) => {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        dispatch(analyticsActions.basketReminderNotificationEvent(EventActions.BASKET_REMINDER_NOTIFICATION_CLICK));
        window.location.href = hrefViewCart;
    };
    useLayoutEffect(() => {
        setTimeout(() => {
            setOpen(true);
            dispatch(analyticsActions.basketReminderNotificationViewed());
        }, DELAY.DELAY_300);
    }, []);
    const popoverOffsetHandler = (navigation) => {
        navigation &&
            setPopoverOffset(navigation.classList.contains(NAVIGATION_HORIZONTAL_COLLAPSE)
                ? POPOVER_OFFSET_COLLAPSED_NAV
                : POPOVER_OFFSET_DEFAULT);
    };
    useEffect(() => {
        const navigation = document.querySelector(NAVIGATION_HORIZONTAL);
        setNavigationEl(navigation);
        popoverOffsetHandler(navigation);
    }, []);
    useScrollPosition(() => {
        navigationEl && popoverOffsetHandler(navigationEl);
    }, [navigationEl]);
    const greetingText = () => `${isLoggedIn
        ? t(`${I18N_NAMESPACES.checkout}:basket.reminder.greeting.loggedIn`, { firstName })
        : t(`${I18N_NAMESPACES.checkout}:basket.reminder.greeting.notLoggedIn`)} 👋`;
    return (_jsxs(Popover, { isOpen: open, hasCloseBtn: true, animated: true, placement: "bottom-end", overflowOptions: isDesktop || isFirefox ? overflowOptions : undefined, offsetOptions: { mainAxis: popoverOffset }, disableTrigger: true, children: [_jsx(Popover.Trigger, { children: children }), _jsx(Popover.Header, { children: _jsx(Box, { paddingBlockStart: "1", paddingBlockEnd: { base: '1', lg: '3' }, children: _jsx(Heading, { size: HeadingSize.M, children: greetingText() }) }) }), _jsxs(Popover.Body, { children: [_jsx(Text, { color: TextColor.SUBTLE, children: t(`${I18N_NAMESPACES.checkout}:basket.reminder.message`, { count: basketAmount }) }), _jsx(Box, { paddingBlockStart: { base: '2', lg: '4' }, paddingBlockEnd: { base: '0', lg: '2' }, children: _jsx(Link, { href: hrefViewCart, variant: LinkVariant.CONTAINER, onClick: onViewBasketClick, children: _jsx(Scrollable, { horizontal: true, clipped: true, children: _jsx("div", { style: { height: isDesktop ? DESKTOP_IMAGE_HEIGHT : ProductImageHeight.THUMB }, children: _jsx(Group, { gutter: GroupGutter.SMALL, inline: true, children: products.slice(0, MAX_PRODUCTS).map(product => {
                                            const imageUrl = getImageSourceSetByProductCode(product.productCode, product.image, productImageConfig);
                                            return (_jsx(Image, { src: imageUrl[ProductImageSizesPortraitEnum.thumb], srcset: {
                                                    [`${MIN_SCREEN_WIDTH_DESKTOP}w`]: imageUrl[ProductImageSizesPortraitEnum.bundles],
                                                }, width: isDesktop ? DESKTOP_IMAGE_WIDTH : ProductImageWidth.THUMB, height: isDesktop ? DESKTOP_IMAGE_HEIGHT : ProductImageHeight.THUMB, alt: product.productCode }, product.sku));
                                        }) }) }) }) }) })] }), _jsx(Popover.Footer, { children: _jsx(ButtonAlpha, { theme: "branded", fullWidth: true, iconRight: {
                        source: ArrowRightIcon,
                    }, text: t(`${I18N_NAMESPACES.checkout}:basket.reminder.ctaLabel`), onClick: onViewBasketClick }) })] }));
};
